import { useCallback } from 'react';
import axios from 'axios';
import { message } from 'antd';
import I18n from 'i18n-js';
import { ticket_comment_path } from 'js-routes/generated/routes';

const useUpdateComment = ({ setComments }) => {
  const handleUpdateComment = useCallback(async (commentId, content) => {
    const response = await axios({
      headers: { Accept: 'application/json, text/javascript' },
      responseType: 'json',
      method: 'patch',
      url: ticket_comment_path(commentId),
      // eslint-disable-next-line camelcase
      data: { ticket_comment: { content } },
    });

    const updatedComment = response.data.comment;

    setComments((prev) => prev.map((comment) => (
      comment.id === commentId ? updatedComment : comment
    )));

    message.success(I18n.t('flash.ticket_comments.updated'));
  }, [setComments]);

  return { handleUpdateComment };
};

export default useUpdateComment;
